
export default {
  name: 'NavBarBrandIcon',
  props: ['icon', 'url', 'color']
}
